export const vcpConfig = state => state.vcpConfig
export const vcpConfigLoaded = state => state.vcpConfigLoaded
export const vcpConfigLoading = state => state.vcpConfigLoading
export const currentTarget = state => state.currentTarget
export const vcpHash = state => state.vcpHash
